'use strict';

/**
 * @classname CreateFavoriteShop
 * @classdesc お気に入り店舗DOM作成
 */
export default class CreateFavoriteShop {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-receiving-shop
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		if($('.header').hasClass('header--logined')) return;
		let shopSelected = window.localStorage.getItem('_cfs_') || null;
		if(shopSelected){
			shopSelected = JSON.parse(shopSelected);
			if(shopSelected.shopId){
				const shopId = shopSelected.shopId;
				const shopName = shopSelected.shopName;
				const shopAddress = shopSelected.shopAddress;
				const shopBusinessHours = shopSelected.shopBusinessHours;
				const html = `
<li class="list__item">
	<div class="input-radio input-radio--favorite-shop">
		<input class="input-radio__input" id="shop-fav${shopId}" name="shop_code" value="${shopId}" type="radio" checked="checked">
		<label class="input-radio__label" for="shop-fav${shopId}">
			<div>
				<strong>${shopName}</strong><br>
				${shopAddress}<br>
				受け取り可能曜日：${shopBusinessHours}
			</div>
		</label>
	</div>
</li>`;
				$('.list--favorite-shop-tab').append(html);
				$('.btn--favorite-shop').prop('disabled', false);
			}else{
				$('#form-favorite-shop').prepend('<div class="tal mb20 block block--text-box">現在登録されている情報はありません。</div>');
			}
		}
	};
};
